import React from 'react';
import { Layout, RoutesMenu, GetInfo } from '../../components';
import '../../assets/styles/containers/Routes.sass';

const Stage1 = () => {
  return (
    <div className="Stage1">
      <Layout bannerId={72}>
        <RoutesMenu/>
        <div className="container">
          <GetInfo id={139}/>
        </div>
      </Layout>
    </div>
  );
};

export default Stage1;
